import { mapGetters } from 'vuex'

/**
 * Mixin for the parent components who would implement the NestedMethod component
 *
 * This mixin manages:
 *  - The height update of the parent element
 *  - The countdown
 */

export const NestedMethodContainerMixin = {
  data() {
    return {
      baseButtonHeight: 0
    }
  },
  computed: {
    ...mapGetters([
      'activeNestedMethod',
      'getMethodExpiry',
      'isActiveMethod',
      'isNestedMethod'
    ])
  },
  methods: {
    updateHeight(height) {
      if (this.baseButtonHeight === 0 && height > 0) {
        this.baseButtonHeight = this.$el.getBoundingClientRect().height
      }

      const value = this.baseButtonHeight + height + 'px'
      this.css.button.height = value
    }
  }
}
